export const VERIFY_SLUG = 'VERIFY_SLUG';
export const SET_VERIFY_SLUG_STATUS = 'SET_VERIFY_SLUG_STATUS';
export const PAYMENT_STEP = 'PAYMENT_STEP';
export const PAYMENT_STATUS = 'PAYMENT_STATUS';
export const SET_BUSINESS_DATA = 'SET_BUSINESS_DATA';
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const CREATE_PAYMENT_LOADER = 'CREATE_PAYMENT_LOADER';
export const SET_USER_PAYMENT_DETAILS = 'SET_USER_PAYMENT_DETAILS';
export const PAYMENT_VERIFY = 'PAYMENT_VERIFY';
export const SET_PAYMENT_VERIFY_STATUS = 'SET_PAYMENT_VERIFY_STATUS';
export const COMPLETE_STRIPE_ONBOARDING = 'COMPLETE_STRIPE_ONBOARDING';
export const COMPLETE_STRIPE_ONBOARDING_SUCCESS = 'COMPLETE_STRIPE_ONBOARDING_SUCCESS';
export const VERIFY_STRIPE_ONBOARDING_STATUS = 'VERIFY_STRIPE_ONBOARDING_STATUS';
export const SET_VERIFY_STRIPE_ONBOARDING_STATUS = 'SET_VERIFY_STRIPE_ONBOARDING_STATUS';
export const GET_PAYMENT_HISTORY_LIST = 'GET_PAYMENT_HISTORY_LIST';
export const GET_KPI_DATA = 'GET_KPI_DATA';
export const SET_KPI_DATA = 'SET_KPI_DATA';
export const GET_NEXT_PAYMENT_LIST = 'GET_NEXT_PAYMENT_LIST';
export const SET_PAYMENT_HISTORY_LIST = 'SET_PAYMENT_HISTORY_LIST';
export const SET_PAYMENT_SLUG = 'SET_PAYMENT_SLUG';
